import './Radio-b2a92b7d.css';

var classes = {"Radio":"prc-Radio-Radio-Ly4MR"};

export { classes as default };
